import { SyntaxError } from "./errors.js";
import { print } from "./commands/print.js";
import { load } from "./commands/load.js";
import { run } from "./commands/run.js";
import { list } from "./commands/list.js";
import { goto } from "./commands/goto.js";
import { newCommand } from "./commands/new.js";

const processUnsupportedCommand = async () => await new SyntaxError().handleError();
const unsupportedCommand = processUnsupportedCommand;

export const commands = {
    CLOSE:    unsupportedCommand,
    CLR:      unsupportedCommand,
    CMD:      unsupportedCommand,
    CONT:     unsupportedCommand,
    DATA:     unsupportedCommand,
    DEF:      unsupportedCommand,
    DIM:      unsupportedCommand,
    END:      unsupportedCommand,
    FOR:      unsupportedCommand,
    GET:      unsupportedCommand,
    "GET#":   unsupportedCommand,
    GOSUB:    unsupportedCommand,
    GOTO:     async(args) => await goto(args),
    IF:       unsupportedCommand,
    INPUT:    unsupportedCommand,
    "INPUT#": unsupportedCommand,
    LET:      unsupportedCommand,
    LIST:     async () => await list(),
    LOAD:     async(args) => await load(args),
    NEW:      async(args) => await newCommand(args),
    NEXT:     unsupportedCommand,
    ON:       unsupportedCommand,
    OPEN:     unsupportedCommand,
    POKE:     unsupportedCommand,
    "?":      async(args) => await print(args),
    PRINT:    async(args) => await print(args),
    "PRINT#": unsupportedCommand,
    READ:     unsupportedCommand,
    REM:      unsupportedCommand,
    RESTORE:  unsupportedCommand,
    RETURN:   unsupportedCommand,
    RUN:      async(args) => await run(args),
    SAVE:     unsupportedCommand,
    ST:       unsupportedCommand,
    STATUS:   unsupportedCommand,
    STEP:     unsupportedCommand,
    STOP:     unsupportedCommand,
    SYS:      unsupportedCommand,
    THEN:     unsupportedCommand,
    TO:       unsupportedCommand,
    VERIFY:   unsupportedCommand,
    WAIT:     unsupportedCommand
};

export const isSupportedCommand = (command) => commands.hasOwnProperty(command) && commands[command] !== unsupportedCommand;